module.exports = "/_next/static/images/PPE-26b9d2eeeeb4b9c92270b1127985eeee.png";